const t = {
  name: "InfrastructureTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_21_2276)">
<path d="M22 -2.44463e-05V5.99998H19.99C18.78 4.37998 17.13 3.18998 15.2 2.52998C13.18 1.84998 11.03 1.82998 8.99 2.46998C6.95 3.10998 5.2 4.36998 3.94 6.08998C2.67 7.81998 2 9.85997 2 12H0C0 9.42998 0.8 6.97998 2.32 4.90998C3.84 2.83998 5.94 1.33998 8.38 0.559976C10.83 -0.210024 13.41 -0.190024 15.84 0.639976C17.4 1.15998 18.8 1.97998 20 3.05998V-2.44463e-05H22Z" fill="currentColor"/>
<path d="M24 12H22C22 14.14 21.33 16.18 20.07 17.91C18.8 19.63 17.05 20.89 15.01 21.53C12.97 22.17 10.82 22.15 8.8 21.47C6.86 20.81 5.21 19.62 4 18H2V24H4V20.94C5.2 22.02 6.6 22.84 8.16 23.36C9.41 23.79 10.7 24 12 24C13.21 24 14.43 23.81 15.62 23.44C18.06 22.67 20.16 21.16 21.68 19.09C23.2 17.02 24 14.57 24 12Z" fill="currentColor"/>
<path d="M11 16V11.4099L8.99984 13.41L7.58984 12L11.9998 7.59003L16.4098 12L14.9998 13.41L13 11.4102V16H11Z" fill="currentColor"/>
<path d="M4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12ZM6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_21_2276">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
  `
};
export {
  t as InfrastructureTeam
};
